class WLSReviews extends HTMLElement {
    constructor() {
        super();

        this.autoplay = this.getAttribute('data-autoplay');
        this.loop = this.getAttribute('data-loop');

        this.testimonialSlider = this.querySelector('#testimonial-slider');
    }

    connectedCallback() {
        this.initSlider();
    }

    initSlider() {
        this.testimonial = new Splide(this.testimonialSlider, {
            type: this.loop === 'true' ? 'loop' : 'slide',
            perPage: 1,
            autoplay: this.autoplay === 'true',
            gap: 16,
            interval: 2500,
            pagination: false
        });
        
        this.testimonial.mount();
    }
}

if (!customElements.get('wls-reviews')) {
    customElements.define('wls-reviews', WLSReviews);
}